import {Box, HStack, Text, VStack} from '@chakra-ui/react';
import {useTranslation} from 'react-i18next';

export const LegendeCalendrier: React.FC = () => {
  const {t} = useTranslation();

  return (
    <VStack
      alignItems='start'
      spacing={2}
      mt={4}
      w='100%'
    >
      {/* Jour sélectionné */}
      <HStack>
        <Box
          borderRadius='full'
          boxSize='12px'
          backgroundColor='blue.main'
        />
        <Text fontWeight={600}>
          {t('modale_livraison.legende.jour_selectionne')}
        </Text>
      </HStack>
      {/* Panier en cours */}
      <HStack>
        <Box
          borderRadius='full'
          boxSize='12px'
          backgroundColor='orange.warning'
        />
        <Text fontWeight={600}>
          {t('modale_livraison.legende.panier_en_cours')}
        </Text>
      </HStack>
      {/* Panier validé */}
      <HStack>
        <Box
          borderRadius='full'
          boxSize='12px'
          backgroundColor='green.success'
        />
        <Text fontWeight={600}>
          {t('modale_livraison.legende.panier_valide')}
        </Text>
      </HStack>
    </VStack>
  );
};
